"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePatientSurvey = exports.getAnswerForQuestion = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _utils = require("../../utils");
var _types = require("../../types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FOREIGN_SECTIONS_NAMES = [_utils.DSM5_PHYSICIAN_COMMENT_SECTION_NAME, _utils.MEDICAL_INTAKE_PHYSICIAN_COMMENT_SECTION_NAME];
var usePatientSurvey = function usePatientSurvey(_ref) {
  var _initialPatientSurvey;
  var patientId = _ref.patientId,
    surveyType = _ref.surveyType,
    _ref$setForeignSectio = _ref.setForeignSections,
    setForeignSections = _ref$setForeignSectio === void 0 ? _lodash.noop : _ref$setForeignSectio,
    _ref$surveyStatuses = _ref.surveyStatuses,
    surveyStatuses = _ref$surveyStatuses === void 0 ? [] : _ref$surveyStatuses;
  var enabled = !!patientId;

  // get all surveys of surveyType and their questions for patient
  var _useRequest = (0, _utils.useRequest)((0, _utils.getSurveyUrl)(surveyType), {
      ready: enabled
    }),
    surveys = _useRequest.data,
    surveyLoading = _useRequest.loading;

  // Get most recent PatientSurveyDto which includes SurveryDto, and PatientAnswerDto[]
  var _useRequest2 = (0, _utils.useRequest)((0, _utils.getPatientSurveyAnswersUrl)({
      patientId: patientId,
      surveyType: surveyType,
      surveyStatuses: surveyStatuses
    }), {
      ready: enabled
    }),
    initialPatientSurveyAndAnswers = _useRequest2.data,
    answersLoading = _useRequest2.loading,
    refreshPatientSurvey = _useRequest2.refreshAsync;
  var loading = surveyLoading || answersLoading;
  var survey = (0, _react.useMemo)(function () {
    if (!surveys || (0, _lodash.isUndefined)(initialPatientSurveyAndAnswers)) {
      return null;
    }
    var targetSurvey = initialPatientSurveyAndAnswers.surveyId ? surveys.find(function (_ref2) {
      var id = _ref2.id;
      return id === initialPatientSurveyAndAnswers.surveyId;
    }) : surveys.find(function (_ref3) {
      var isArchived = _ref3.isArchived;
      return !isArchived;
    });
    if (!targetSurvey) {
      throw new Error('targetSurvey not found!');
    }
    var targetSurveyWithSections = _objectSpread(_objectSpread({}, targetSurvey), {}, {
      sections: groupQuestionsBySection(targetSurvey.questions)
    });
    if (surveyType === _types.SurveyTypesEnum.PhysicianAssessment) {
      var _partition = (0, _lodash.partition)(targetSurveyWithSections.questions, function (question) {
          var _question$surveySecti;
          return FOREIGN_SECTIONS_NAMES.includes(((_question$surveySecti = question.surveySection) === null || _question$surveySecti === void 0 ? void 0 : _question$surveySecti.name) || '');
        }),
        _partition2 = _slicedToArray(_partition, 2),
        foreignQuestions = _partition2[0],
        ownQuestions = _partition2[1];
      var ownSections = groupQuestionsBySection(ownQuestions);
      var foreignSections = groupQuestionsBySection(foreignQuestions);
      setForeignSections(foreignSections);
      targetSurveyWithSections.sections = ownSections;
    }
    return targetSurveyWithSections;
  }, [surveys, initialPatientSurveyAndAnswers, loading]);
  return {
    loading: loading,
    patientSurvey: initialPatientSurveyAndAnswers,
    survey: survey,
    patientSurveyAnswers: initialPatientSurveyAndAnswers === null || initialPatientSurveyAndAnswers === void 0 ? void 0 : (_initialPatientSurvey = initialPatientSurveyAndAnswers.patientAnswers) === null || _initialPatientSurvey === void 0 ? void 0 : _initialPatientSurvey.filter(function (x) {
      return x.isDeleted === false;
    }),
    refreshPatientSurvey: refreshPatientSurvey
  };
};
exports.usePatientSurvey = usePatientSurvey;
var groupQuestionsBySection = function groupQuestionsBySection(questions) {
  return (0, _lodash.groupBy)(questions, function (question) {
    var _question$surveySecti2;
    return (_question$surveySecti2 = question.surveySection) === null || _question$surveySecti2 === void 0 ? void 0 : _question$surveySecti2.name;
  });
};
var getAnswerForQuestion = function getAnswerForQuestion(question, patientSurveyAnswers) {
  return patientSurveyAnswers && patientSurveyAnswers.find(function (answer) {
    return String(answer.questionId) === String(question.id);
  });
};
exports.getAnswerForQuestion = getAnswerForQuestion;